import DBOperationsComb from "src/utils/dbOperationsComb";
import Exception from "src/utils/exception";
import Constants from "src/utils/constants";

async function getStatusCounts(
  formTemplateId,
  areaIds,
  regionID = null,
  dateRange = null,
  statuses = null
) {
  try {
    if (formTemplateId === Constants.enums.FORM_TEMPLATE_IDS.DEFECTS_FORM) {
      return await DBOperationsComb.getStatusCounts({
        formTemplateId,
        areaIds,
        dateRange,
        regionId: regionID
      });
    } else if (
      formTemplateId === Constants.enums.FORM_TEMPLATE_IDS.INSPECTION_FORM
    ) {
      return await DBOperationsComb.getInspectionCounts({
        formTemplateId,
        areaIds,
        dateRange,
        regionId: regionID
      });
    } else if (
      formTemplateId ===
      Constants.enums.FORM_TEMPLATE_IDS.EMERGENCY_RESPONSE_FORM
    ) {
      return await DBOperationsComb.getEmergencyResponseCounts({
        formTemplateId,
        areaIds,
        dateRange,
        regionId: regionID,
        statuses
      });
    }
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

// PHO-1207: FLHA KPI summary — year-to-date card values plus current/previous
// month totals (MoM %) and current/previous week Open-Action counts (week delta).
// Each *_range is a [fromISO, toISO] pair computed client-side.
async function getFlhaSummary(
  formTemplateId,
  areaIds = null,
  regionID = null,
  yearRange = null,
  thisMonth = null,
  lastMonth = null,
  thisWeek = null,
  lastWeek = null
) {
  try {
    return await DBOperationsComb.getFlhaSummary({
      formTemplateId,
      areaIds,
      regionId: regionID,
      yearRange,
      thisMonth,
      lastMonth,
      thisWeek,
      lastWeek
    });
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getHighwayPins(
  formTemplateId,
  typeID = null,
  areaIds = null,
  highwayIDs = null,
  searchTxt = null,
  statuses = null,
  dateRange = null,
  regionID = null,
  priority = null,
  number = null
) {
  try {
    if (formTemplateId === Constants.enums.FORM_TEMPLATE_IDS.DEFECTS_FORM) {
      return await DBOperationsComb.getHighwayPins({
        formTemplateId,
        typeId: typeID,
        areaIds,
        highwayIds: highwayIDs,
        searchTxt,
        statuses,
        dateRange,
        regionId: regionID,
        priority,
        number
      });
    } else if (
      formTemplateId === Constants.enums.FORM_TEMPLATE_IDS.INSPECTION_FORM
    ) {
      return await DBOperationsComb.getInspectionHighwayPins({
        formTemplateId,
        typeId: typeID,
        areaIds,
        highwayIds: highwayIDs,
        searchTxt,
        dateRange,
        regionId: regionID,
        number
      });
    } else if (
      formTemplateId ===
      Constants.enums.FORM_TEMPLATE_IDS.EMERGENCY_RESPONSE_FORM
    ) {
      return await DBOperationsComb.getEmergencyResponsePins({
        formTemplateId,
        typeId: typeID,
        areaIds,
        highwayIds: highwayIDs,
        searchTxt,
        statuses,
        dateRange,
        regionId: regionID
      });
    }
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getWeeklyEmergencyResponsesExport(
  formTemplateId,
  areaIds = null,
  regionID = null,
  dateRange = null
) {
  try {
    return await DBOperationsComb.getWeeklyEmergencyResponsesExport({
      formTemplateId,
      areaIds,
      regionId: regionID,
      dateRange
    });
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  getStatusCounts,
  getFlhaSummary,
  getHighwayPins,
  getWeeklyEmergencyResponsesExport
};
